import { useTranslation } from 'react-i18next';
import { dayjs } from '@koob/dates';
import { KoobTooltip } from '@koob/ui';
import {
  TripDay,
  TripDayExperience,
  TripDayHotel,
  useTripDesignerConfig,
  useTripFilters,
} from '@koob/trip-designer';
import ExperienceExtrasModal from '../../../Experiences/Partials/ExperienceExtrasModal';
import HotelRoomSelectionModal from '../../../../components/Hotel/HotelRoomSelectionModal';
import { useLanguage, useSnack } from '../../../../hooks';
import { useTripHotelCardProps } from './tripHotelCard';

// KD-3643 — the corner "cannot be booked" warning of a product, shared by
// the hotel and the experience day.
const renderAccessAlert = ({ tooltip }) => (
  <KoobTooltip tip={tooltip} color="red" hasArrow={false} position="left">
    <i
      className="fa-light fa-triangle-exclamation"
      style={{ fontSize: 20, color: 'red' }}
    />
  </KoobTooltip>
);

// One day card with the app's own pieces slotted in: access alert, extras
// modal, room selection modal and the hotel card labels.
export default function ComposeMapDay({
  dayIndex,
  frameProps,
  addExperience,
  addHotel,
  registerHotelWarning,
}) {
  const { t } = useTranslation('tripDesigner');
  const { lang } = useLanguage();
  const tripHotelCardProps = useTripHotelCardProps();
  const { onEvent } = useTripDesignerConfig();
  const { notify } = useSnack();
  const tripFilters = useTripFilters();

  if (!dayjs(tripFilters?.departureDate).isValid()) return null;

  return (
    <TripDay
      dayIndex={dayIndex}
      {...frameProps}
      date={dayjs(tripFilters.departureDate).add(dayIndex, 'days')}
      registerHotelWarning={registerHotelWarning}
      translation={t}
      renderExperience={(idx, sharedProps) => (
        <TripDayExperience
          dayIndex={idx}
          {...sharedProps}
          addExperience={addExperience}
          translation={t}
          notify={notify}
          onEvent={onEvent}
          renderAccessAlert={renderAccessAlert}
          renderExtrasModal={modalProps => (
            <ExperienceExtrasModal {...modalProps} />
          )}
        />
      )}
      renderHotelSelector={(idx, sharedProps) => (
        <TripDayHotel
          dayIndex={idx}
          {...sharedProps}
          addHotel={addHotel}
          translation={t}
          locale={lang}
          tripHotelCardProps={tripHotelCardProps}
          onEvent={onEvent}
          renderAccessAlert={renderAccessAlert}
          renderRoomSelectionModal={modalProps => (
            <HotelRoomSelectionModal {...modalProps} />
          )}
        />
      )}
    />
  );
}
